export enum SessionHitTypes {
  pageView = 'pageView',
  event = 'event'
}

export enum PredefinedHitCategories {
  ecommerce = 'ecommerce'
}

export enum EcommerceHitEventActions {
  productView = 'productView',
  orderPlace = 'orderPlace',
  addToCart = 'addToCart'
}

export enum ProductValueTypes {
  Views = 'views',
  Purchases = 'purchases',
  Revenue = 'revenue'
}

export enum FilterOptions {
  enrollment = 'enrollment',
  activity = 'activity',
  sales = 'sales',
  visiting = 'visiting'
}
